// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_HkV","cls2":"Unibrow-cls2_5kt Unibrow-cls1_HkV"};